<template>
  <a
    v-if="url"
    class="service-agreement-link"
    :href="url"
    target="_blank"
    rel="noopener noreferrer"
    @click.stop
    @keydown.enter.stop
    >{{ text }}</a
  >
  <span v-else>{{ text }}</span>
</template>

<script>
/**
 * Renders the Direct Debit Request Service Agreement as a link to the published PDF, for use
 * inside checkbox label text on the direct debit screens.
 *
 * Opening in a new tab lets the browser's built-in viewer handle both display and download, so no
 * PDF viewer library is needed. Clicks and activation keys are stopped so following the link never
 * toggles the checkbox whose label contains it — the rest of the label still does.
 *
 * The URL is supplied by the parent screen, which reads it at runtime from
 * `/users/direct-debit/service-agreement` so it resolves to the version currently in effect for the
 * customer's origin type. When it is empty the phrase still renders as plain text, so a missing
 * document degrades to unlinked wording rather than blocking the customer from completing the
 * screen.
 */
export default {
  props: {
    text: {
      type: String,
      required: false,
      default: 'Direct Debit Request Service Agreement',
    },
    url: {
      type: String,
      required: false,
      default: '',
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/styles/global.scss';

// Both direct debit designs set the phrase in the same colour as the acknowledgement text around
// it and mark it with the underline alone, so the colour is inherited rather than branded.
.service-agreement-link {
  color: inherit;
  text-decoration: underline;
  cursor: pointer;

  &:hover {
    text-decoration-thickness: 2px;
  }

  &:focus-visible {
    outline: 2px solid currentColor;
    outline-offset: 2px;
  }
}
</style>
